<div class="card">
  <div class="card-top">
    <div class="card-top-text">
      {{ courseSession?.titulo }}
    </div>
    <div class="wave d-flex justify-content-center align-content-center">
      <p class="mt-2">
        <span>Id Localizador: {{ courseSession?.IdLocalizador }}</span>
      </p>
    </div>
  </div>
  <div class="card-body">
    <h4 class="card-title font-weight-bold">
      Fecha del curso: {{ courseSession?.fechaInicio | date: "dd/MMM/yyyy" }}
    </h4>
    <img
      src="../../../../../assets/Icons/logo.svg"
      [alt]="courseSession?.titulo"
      style="max-width: 100%; height: 50%" />
    <a class="btn btn-primario btn-pequeno" (click)="openModal()"
      ><span>Generar QR</span></a
    >
    <span class="mt-3">
      Fecha de alta: {{ courseSession?.fechaAlta | date: "dd/MMM/yyyy" }} <br />
    </span>
  </div>
</div>
